<template>
  <div class="d-flex justify-start align-center mt-1">
    <BaseActionsButton
      id="viewDetailsEmployees"
      name="viewDetailsEmployees"
      iconName="mdi-eye"
      iconColor="primary"
      customClass="mr-2"
      tooltipMessage="View Details"
      @click="viewDetails()"
    ></BaseActionsButton>
    <BaseActionsButton
      id="editEmployee"
      name="editEmployee"
      iconName="mdi-pencil"
      iconColor="primary"
      customClass="mr-2"
      tooltipMessage="Edit Details"
      @click="editEmployee()"
    ></BaseActionsButton>
  </div>
</template>

<script>
export default {
  methods: {
    editEmployee() {
      this.params.context.parentComponent.editEmployee(this.params.data.id);
    },
    viewDetails() {
      this.params.context.parentComponent.viewDetails(this.params.data.id);
    },
  },
};
</script>

<style>
</style>